import { Outlet } from 'react-router-dom';
import { PlanningHeader } from '@/features/planning/components/PlanningHeader';
import { PlanningSidebar } from '@/features/planning/components/PlanningSidebar';

export function PlanningLayout() {
  return (
    <div className="flex h-screen bg-background text-foreground">
      <PlanningSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <PlanningHeader />
        <main className="flex-1 overflow-auto p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
